import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './App.css';
import Home from './pages/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import TopButton from './components/Ui/TopButton';
import useUiStore from './components/store/uiStore';
import About from './pages/About';
import Login from './pages/Login';
import Signup from './pages/Signup';
import News from './pages/News';
import NewsDetail from './pages/news/NewsDetail';
import Consulting from './pages/Consulting';
import EnterpriseBrandIdentity from './pages/consulting/EnterpriseBrandIdentity';
import EnterpriseEnvironment from './pages/consulting/EnterpriseEnvironment';
import EnterpriseProduct from './pages/consulting/EnterpriseProduct';
import EnterpriseGraphic from './pages/consulting/EnterpriseGraphic';
import EnterpriseBeauty from './pages/consulting/EnterpriseBeauty';
import PersonalColor from './pages/consulting/PersonalColor';
import PersonalTherapy from './pages/consulting/PersonalTherapy';
import PersonalImage from './pages/consulting/PersonalImage';
import PersonalBranding from './pages/consulting/PersonalBranding';
import Program from './pages/Program';
import Membership from './pages/Membership';
import MemberGuide from './pages/MemberGuide';
import YearlyColor from './pages/YearlyColor';
import AdminPage from './pages/admin/AdminPage';
import AdminLogin from './pages/admin/login/AdminLogin';
import AdminNotices from './pages/admin/notices/AdminNotices';
import NoticeFormPage from './pages/admin/notices/notice-form/NoticeFormPage';
import PressFormPage from './pages/admin/notices/press-form/PressFormPage';
import SeminarFormPage from './pages/admin/notices/seminar-form/SeminarFormPage';
import HistoryFormPage from './pages/admin/notices/history-form/HistoryFormPage';
import OrganizationFormPage from './pages/admin/notices/organization-form/OrganizationFormPage';
import YearColorFormPage from './pages/admin/notices/year-color-form/YearColorFormPage';
import AdminLayout from './pages/admin/layout';

function AppContent() {
  const location = useLocation();
  const [, setFooterActive] = useState(false);
  useUiStore((state) => state.showForm);

  // 페이지별 그라데이션 색상 설정 (RGB 값)
  const getPageColor = (pathname) => {
    const pageColors = {
      '/about': { r: 254, g: 140, b: 134 },
      '/news': { r: 169, g: 168, b: 232 },
      '/news/notice': { r: 169, g: 168, b: 232 },
      '/news/press': { r: 169, g: 168, b: 232 },
      '/news/seminar': { r: 169, g: 168, b: 232 },
      '/consulting': { r: 247, g: 169, b: 195 },
      '/consulting/enterprise-brand-identity': { r: 247, g: 169, b: 195 },
      '/consulting/enterprise-environment': { r: 247, g: 169, b: 195 },
      '/consulting/enterprise-product': { r: 247, g: 169, b: 195 },
      '/consulting/enterprise-graphic': { r: 247, g: 169, b: 195 },
      '/consulting/enterprise-beauty': { r: 247, g: 169, b: 195 },
      '/consulting/personal-color': { r: 247, g: 169, b: 195 },
      '/consulting/personal-therapy': { r: 247, g: 169, b: 195 },
      '/consulting/personal-image': { r: 247, g: 169, b: 195 },
      '/consulting/personal-branding': { r: 247, g: 169, b: 195 },
      '/program': { r: 253, g: 201, b: 131 },
      '/membership': { r: 116, g: 197, b: 233 },
      '/member-guide': { r: 116, g: 197, b: 233 }
    };

    // news 상세 페이지 경로 매칭 (동적 경로 처리)
    let gradientKey = pathname;
    if (pathname.startsWith('/news/notice/') || 
        pathname.startsWith('/news/press/') || 
        pathname.startsWith('/news/seminar/')) {
      gradientKey = pathname.split('/').slice(0, 3).join('/');
    }
    
    return pageColors[gradientKey] || pageColors[pathname] || null;
  };

  useEffect(() => {
    // 페이지 이동 시 스크롤을 상단으로 이동
    window.scrollTo(0, 0);
    
    const isAdminPage = location.pathname.startsWith('/admin');
    
    // body 배경 설정
    if (location.pathname === '/' || isAdminPage) {
      document.body.style.background = isAdminPage ? '#ffffff' : '#fbfafa';
    } else {
      document.body.style.background = '#ffffff';
    }
  }, [location.pathname]);

  const pageColor = getPageColor(location.pathname);

  // 관리자 페이지는 Footer 없이 표시 (Header는 표시)
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:type/:id" element={<NewsDetail />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/consulting/enterprise-brand-identity" element={<EnterpriseBrandIdentity />} />
        <Route path="/consulting/enterprise-environment" element={<EnterpriseEnvironment />} />
        <Route path="/consulting/enterprise-product" element={<EnterpriseProduct />} />
        <Route path="/consulting/enterprise-graphic" element={<EnterpriseGraphic />} />
        <Route path="/consulting/enterprise-beauty" element={<EnterpriseBeauty />} />
        <Route path="/consulting/personal-color" element={<PersonalColor />} />
        <Route path="/consulting/personal-therapy" element={<PersonalTherapy />} />
        <Route path="/consulting/personal-image" element={<PersonalImage />} />
        <Route path="/consulting/personal-branding" element={<PersonalBranding />} />
        <Route path="/program" element={<Program />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/member-guide" element={<MemberGuide />} />
        <Route path="/yearly-color" element={<YearlyColor />} />
        
        {/* 관리자 페이지 라우트 */}
        <Route path="/admin" element={<AdminLayout><AdminPage /></AdminLayout>} />
        <Route path="/admin/login" element={<AdminLayout><AdminLogin /></AdminLayout>} />
        <Route path="/admin/notices" element={<AdminLayout><AdminNotices /></AdminLayout>} />
        <Route path="/admin/notices/notice-form" element={<AdminLayout><NoticeFormPage /></AdminLayout>} />
        <Route path="/admin/notices/press-form" element={<AdminLayout><PressFormPage /></AdminLayout>} />
        <Route path="/admin/notices/seminar-form" element={<AdminLayout><SeminarFormPage /></AdminLayout>} />
        <Route path="/admin/notices/history-form" element={<AdminLayout><HistoryFormPage /></AdminLayout>} />
        <Route path="/admin/notices/organization-form" element={<AdminLayout><OrganizationFormPage /></AdminLayout>} />
        <Route path="/admin/notices/year-color-form" element={<AdminLayout><YearColorFormPage /></AdminLayout>} />
      </Routes>
      {!isAdminPage && (
        <>
          <Footer setFooterActive={setFooterActive} pageColor={pageColor} />
          <TopButton />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
